import { render } from "./policy-modal.vue?vue&type=template&id=6480c711"
import script from "./policy-modal.vue?vue&type=script&lang=js"
export * from "./policy-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__